/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelReattachmentRequestDto
 */
export interface CancelReattachmentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CancelReattachmentRequestDto
     */
    ticketId: string;
    /**
     * 
     * @type {string}
     * @memberof CancelReattachmentRequestDto
     */
    action: CancelReattachmentRequestDtoActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CancelReattachmentRequestDto
     */
    targetWorkOrderId?: string;
}


/**
 * @export
 */
export const CancelReattachmentRequestDtoActionEnum = {
    Move: 'move',
    CreateReplacement: 'createReplacement'
} as const;
export type CancelReattachmentRequestDtoActionEnum = typeof CancelReattachmentRequestDtoActionEnum[keyof typeof CancelReattachmentRequestDtoActionEnum];


/**
 * Check if a given object implements the CancelReattachmentRequestDto interface.
 */
export function instanceOfCancelReattachmentRequestDto(value: object): value is CancelReattachmentRequestDto {
    if (!('ticketId' in value) || value['ticketId'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function CancelReattachmentRequestDtoFromJSON(json: any): CancelReattachmentRequestDto {
    return CancelReattachmentRequestDtoFromJSONTyped(json, false);
}

export function CancelReattachmentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelReattachmentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketId': json['ticketId'],
        'action': json['action'],
        'targetWorkOrderId': json['targetWorkOrderId'] == null ? undefined : json['targetWorkOrderId'],
    };
}

export function CancelReattachmentRequestDtoToJSON(json: any): CancelReattachmentRequestDto {
    return CancelReattachmentRequestDtoToJSONTyped(json, false);
}

export function CancelReattachmentRequestDtoToJSONTyped(value?: CancelReattachmentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ticketId': value['ticketId'],
        'action': value['action'],
        'targetWorkOrderId': value['targetWorkOrderId'],
    };
}

